import React, { useEffect, useState } from "react";
import Icon from "../../components/Icon";

import PanelTemplate from "../../templates/Panel";
import DotStatus from "../../components/DotStatus";
import BoxTabs from "../../components/BoxTabs";
import InputSelect from "../../components/InputSelect";
import Input from "../../components/Input";
import InputRadio from "../../components/InputRadio";
import InputEditor from "../../components/InputEditor";
import InputCheckboxes from "../../components/InputCheckboxes";
import PageFooter from "../../components/PageFooter";
import Button from "../../components/Button";
import InputColors from "../../components/InputColors";
import PageHeader from "../../components/PageHeader";
import InputTextarea from "../../components/InputTextarea";
import Box from "../../components/Box";
import Table from "../../components/Table";
import Modal from "../../components/Modal";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import api from "../../services/api";
import { renderError } from "../../helpers/errors";
import { createOptions } from "../../helpers/selects";
import moment from "moment";
import { convertIntToMoney, convertMoenyToInt } from "../../helpers/conversions";
import ModalProduct from "./ModalProduct";
import { toast } from "react-toastify";
import { ModalDelete } from "../../components/ModalDelete";
import { canSeeBrands, hasPermission, hasPlanFeature, hasQuoteDeletePermission } from "../../services/auth";
import SelectBillingCompany from "../../components/selects/SelectBillingCompany";
import SelectStatus from "../../components/selects/SelectStatus";
import SelectCustomerCompany from "../../components/selects/SelectCustomerCompany";
import SelectCustomer from "../../components/selects/SelectCustomer";
import SelectAdmin from "../../components/selects/SelectAdmin";
import SelectBrand from "../../components/selects/SelectBrand";
import InputEditorFull from "../../components/InputEditorTiny";
import InputCheckboxUnique from "../../components/InputCheckboxUnique";
import ModalCreateAddress from "../../components/ModalCreateAddress";
import SelectAddress from "../../components/selects/SelectAddress";
import PaymentConditionFields from "../../components/PaymentCondition";
import { emptyPayment, paymentFromResource, paymentPayload } from "../../components/PaymentCondition/helpers";
import SelectShippingCompany from "../../components/selects/SelectShippingCompany";
import './styles.scss';

const budgetTypes = [
    {label: 'Pessoa física', value: 'PF'},
    {label: 'Pessoa jurídica', value: 'PJ'}
];

const yesOrNoOptions = [
    {label: 'Sim', value: true},
    {label: 'Não', value: false}
];

const shippingTypes = [
    {label: 'CIF - Não aparece no PDF', value: 'CIF'},
    {label: 'FOB - Aparece no PDF', value: 'FOB'}
];

const QuoteDetailsTab = ({
    quote,
    selectedBillingCompany,
    setSelectedBillingCompany,
    selectedStatus,
    setSelectedStatus,
    selectedBudgetType,
    setSelectedBudgetType,
    selectedCustomerCompany,
    setSelectedCustomerCompany,
    selectedCustomer,
    setSelectedCustomer,
    selectedAdmin,
    setSelectedAdmin,
    setAdmins,
    email,
    phone,
    cpf,
    total,
    subtotal,
    comments,
    setComments,
    selectedShippingType,
    setSelectedShippingType,
    payment,
    setPayment,
    shippingFee,
    setShippingFee,
    shippingTime,
    setShippingTime,
    shippingConsult,
    setShippingConsult,
    adminComments,
    setAdminComments,
    setCustomerData,
    setPaymentOption,
    paymentOption,
    shippingAddressId,
    setShippingAddressId,
    customerPurchaseOrder,
    setCustomerPurchaseOrder,
    shippingCompany,
    setShippingCompany,
    selectedBrand,
    setSelectedBrand
}) => {
    return (
        <>
            <div className="row">
                <div className="col-2">
                    <Input
                        label={`Código do orçamento`}
                        value={quote?.code}
                        disabled={true}
                    />
                </div>
                <div className="col-2">
                    <Input
                        label={`Pedido do cliente`}
                        value={customerPurchaseOrder}
                        change={setCustomerPurchaseOrder}
                    />
                </div>
                <div className="col-3">
                    <SelectBillingCompany
                        selectedBillingCompany={selectedBillingCompany}
                        setSelectedBillingCompany={setSelectedBillingCompany}
                    />
                </div>
                <div className="col-3">
                    <SelectStatus
                        type="budget"
                        selectedStatus={selectedStatus}
                        setSelectedStatus={setSelectedStatus}
                    />
                </div>
                <div className="col-2">
                    <Input
                        label={`Data da solicitação`}
                        value={quote?.created_at ? moment(quote.created_at).format('DD/MM/YYYY HH:mm') : ''}
                        disabled={true}
                    />
                </div>
            </div>
            <div className="row">
                {canSeeBrands() &&
                    <div className="col-3">
                        <SelectBrand
                            selectedBrand={selectedBrand}
                            setSelectedBrand={setSelectedBrand}
                        />
                    </div>
                }
                <div className="col-3">
                    <InputSelect
                        label={`Tipo do cliente`}
                        options={budgetTypes}
                        value={selectedBudgetType}
                        change={setSelectedBudgetType}
                    />
                </div>
                {selectedBudgetType === "PJ" &&
                    <div className="col-3">
                        <SelectCustomerCompany
                            selectedCustomerCompany={selectedCustomerCompany}
                            setSelectedCustomerCompany={setSelectedCustomerCompany}
                            create={true}
                        />
                    </div>
                }
                <div className="col-3">
                    <SelectCustomer
                        relatedWithCompany={selectedBudgetType === 'PJ'}
                        companyId={selectedCustomerCompany}
                        selectedCustomer={selectedCustomer}
                        setSelectedCustomer={setSelectedCustomer}
                        setCustomerData={setCustomerData}
                        perPage={50}
                        create={{
                            type: ['customer'],
                            companies: selectedBudgetType === 'PJ' && selectedCustomerCompany ? [selectedCustomerCompany] : null,
                        }}
                    />
                    {/* <InputSelect
                        label={`Pessoa`}
                        options={createOptions(customers, ['code', 'name'], 'id')}
                        value={selectedCustomer}
                        change={setSelectedCustomer}
                    /> */}
                </div>
                <div className="col-3">
                    <SelectAdmin
                        selectedAdmin={selectedAdmin}
                        setSelectedAdmin={setSelectedAdmin}
                        onLoad={setAdmins}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-3">
                    <Input
                        label={`E-mail`}
                        value={email}
                        disabled={true}
                    />
                    
                </div>
                <div className="col-3">
                    <Input
                        label={`Telefone`}
                        value={phone}
                        disabled={true}
                    />
                </div>
                <div className="col-3">
                    <Input
                        label={`CPF`}
                        value={cpf}
                        disabled={true}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-6">
                    <InputEditorFull label={`Observações`} value={adminComments} change={setAdminComments} />
                </div>
                <div className="col-6">
                    <InputTextarea rows={9} label={`Observações do cliente`} disabled={true} value={comments} />
                </div>
            </div>
            <h2 className="section-title">Entrega</h2>
            <div className="row">
                <div className="col-3">
                    <SelectShippingCompany 
                        selectedShippingCompany={shippingCompany}
                        setSelectedShippingCompany={setShippingCompany}
                        create={true}
                    />
                </div>
            </div>
            <div className="row">
            
                <div className="col-3">
                    {(selectedCustomer || selectedCustomerCompany) &&
                        <SelectAddress
                            type={`shipping`}
                            customerId={selectedBudgetType === 'PJ' ? null : selectedCustomer}
                            companyId={selectedBudgetType === 'PJ' ? selectedCustomerCompany : null}
                            addressId={shippingAddressId}
                            setAddressId={setShippingAddressId}
                        />
                    }
                    {!selectedCustomer && !selectedCustomerCompany &&
                        <Input label={`Endereço de entrega`} disabled={true} value={``} />
                    }
                </div>
                <div className="col-3">
                    <Input 
                        label={`Valor do frete`}
                        value={shippingConsult ? '' : shippingFee}
                        change={setShippingFee}
                        mask={`convertToMoney`}
                        disabled={shippingConsult}
                    />
                    <div style={{ marginTop: -10 }}>
                        <InputCheckboxUnique checked={shippingConsult} change={setShippingConsult} label={`A consultar`} />
                    </div>
                </div>
                <div className="col-3">
                    <Input 
                        label={`Prazo de entrega`}
                        value={shippingTime}
                        change={setShippingTime}
                    />
                </div>
                <div className="col-3">
                    <InputSelect
                        label={`Tipo do frete`}
                        options={shippingTypes}
                        value={selectedShippingType}
                        change={setSelectedShippingType}
                    />
                </div>
            </div>
            <h2 className="section-title">Pagamento</h2>
            <div className="row">
                <div className="col-3">
                    <Input 
                        label={`Subtotal`}
                        value={subtotal}
                        disabled={true}
                    />
                </div>
                <div className="col-3">
                    <Input 
                        label={`Total`}
                        value={total}
                        disabled={true}
                    />
                </div>
                <PaymentConditionFields value={payment} change={setPayment} companyId={selectedCustomerCompany} />
            </div>
        </>
    );
}

export const QuoteEdit = () => {
    const { id } = useParams();
    const navigete = useNavigate();
    const location = useLocation();

    const [loading, setLoading] = useState(true);
    const [currentTab, setCurrentTab] = useState(0);

    const [quote, setQuote] = useState(null);

    const [selectedBudgetType, setSelectedBudgetType] = useState(null);
    const [selectedAdmin, setSelectedAdmin] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [selectedBillingCompany, setSelectedBillingCompany] = useState(null);
    const [selectedCustomerCompany, setSelectedCustomerCompany] = useState(null);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [selectedBrand, setSelectedBrand] = useState(null);
    

    const [items, setItems] = useState([]);
    const [itemsData, setItemsData] = useState({header: [], rows: []});

    const [proposalsData, setProposalsData] = useState({header: [], rows: []});

    const [attachmentData, setAttachmentData] = useState({header: [], rows: []});
    
    const [customerPurchaseOrder, setCustomerPurchaseOrder] = useState('');
    const [email, setEmail] = useState('');
    const [shippingFee, setShippingFee] = useState('R$ 0,00');
    const [phone, setPhone] = useState('');
    const [cpf, setCpf] = useState('');
    const [comments, setComments] = useState('');
    const [adminComments, setAdminComments] = useState('');
    const [total, setTotal] = useState('R$ 0,00');
    const [subtotal, setSubtotal] = useState('R$ 0,00');
    
    const [selectedShippingType, setSelectedShippingType] = useState(null);
    const [shippingConsult, setShippingConsult] = useState(true);
    const [shippingTime, setShippingTime] = useState(0);

    const [shippingCompany, setShippingCompany] = useState([]);

    const [paymentOption, setPaymentOption] = useState(null);

    const [payment, setPayment] = useState(emptyPayment);

    const [shippingAddressId, setShippingAddressId] = useState(null);

    const [itemToEdit, setItemToEdit] = useState(null);
    const [showAddProduct, setShowAddProduct] = useState(false);

    const [productToDelete, setProductToDelete] = useState(null);

    const [confirmDelete, setConfirmDelete] = useState(false);

    const [selectedIds, setSelectedIds] = useState([]);
    const [showConfirmMultipleDelete, setShowConfirmMultipleDelete] = useState(false);
    const [showDeletedProductModal, setShowDeletedProductModal] = useState(false);
    const [sellerConfirm, setSellerConfirm] = useState(null);
    const [admins, setAdmins] = useState([]);

    useEffect(() => {
        getQuote();
    }, []);

    useEffect(() => {
        if(quote !== null) getItems();
    }, [quote]);

    useEffect(() => {
        generateItemsData();
        getTotal();
    }, [items]);

    useEffect(() => {
        getTotal();
    }, [selectedShippingType, shippingFee]);
    
    useEffect(() => {
        if(itemToEdit !== null || productToDelete !== null){
            updateQuote(false, false, false, true);
        }
    }, [itemToEdit, productToDelete]);

    useEffect(() => {
        setSelectedCustomer(null);
        setSelectedCustomerCompany(null);
    }, [selectedBudgetType]);

    useEffect(() => {
        if(quote) generateProposalsData();
    }, [quote]);

    const getQuote = () => {
        setLoading(true);

        api.get(`/budget/${id}`).then(res => {
            let resource = res.data.resource;
            setQuote(resource);
            setShippingFee('R$ ' + convertIntToMoney(resource.shipping_fee));
            setCustomerPurchaseOrder(resource.customer_purchase_order);
            setSelectedBudgetType(resource.type);
            setSelectedStatus(resource.status_id);
            setSelectedAdmin(resource.admin_id);
            setSelectedBillingCompany(resource.billing_company_id);
            setShippingCompany(resource.shipping_company_id);       
            setSelectedCustomerCompany(resource.company_id);
            setSelectedCustomer(resource.customer_id);
            setSelectedBrand(resource.brand_id ?? resource.brand?.id ?? null);
            setSelectedShippingType(resource.shipping_type);
            setShippingTime(resource.shipping_time);
            setShippingConsult(resource.shipping_consult);
            setPayment(paymentFromResource(resource));
            setShippingAddressId(resource.shipping_address_id);
            setComments(resource.comments ?? '');
            setAdminComments(resource.admin_comments ?? '');
            setEmail(resource.customer_email ?? resource.customer?.email ?? '');
            setPhone(resource.customer_phone ?? resource.customer?.phone ?? '');
            setCpf(resource.customer_cpf ?? resource.customer?.cpf ?? '');
        }).catch(error => {
            renderError(error);
        }).then(() => setLoading(false));
    }

    // Cadastros (empresa/cliente) do orçamento que ainda não estão com o
    // responsável escolhido. Se o select apontar para outro cadastro que não o
    // carregado, não sabemos o responsável dele e perguntamos do mesmo jeito.
    const getSellerTargets = () => {
        if(!selectedAdmin) return [];

        const targets = [];
        if(selectedBudgetType === 'PJ' && selectedCustomerCompany){
            const company = quote?.company?.id === selectedCustomerCompany ? quote.company : null;
            if(company?.admin_id !== selectedAdmin){
                targets.push({ label: 'pela empresa', name: company?.trade_name || company?.company_name });
            }
        }
        if(selectedCustomer){
            const customer = quote?.customer?.id === selectedCustomer ? quote.customer : null;
            if(customer?.admin_id !== selectedAdmin){
                targets.push({ label: 'pela pessoa', name: customer?.name });
            }
        }
        return targets;
    }

    const saveQuote = (createProposal = false, send = false, createOrder = false) => {
        const targets = getSellerTargets();
        if(targets.length > 0){
            const adminName = admins.find(admin => admin.id === selectedAdmin)?.name;
            setSellerConfirm({ adminName, targets, args: [createProposal, send, createOrder] });
            return;
        }
        updateQuote(createProposal, send, createOrder);
    }

    const confirmSeller = associateSeller => {
        const [createProposal, send, createOrder] = sellerConfirm.args;
        setSellerConfirm(null);
        updateQuote(createProposal, send, createOrder, false, associateSeller);
    }

    const updateQuote = (createProposal = false, send = false, createOrder = false, forcedUpdate = false, associateSeller = false) => {
        if(!forcedUpdate){
            setLoading(true);
        }

        api.put(`/budget/${quote.id}`, {
            customer_purchase_order: customerPurchaseOrder,
            send,
            create_proposal: createProposal,
            type: selectedBudgetType,
            billing_company_id: selectedBillingCompany,
            shipping_company_id: shippingCompany,
            company_id: selectedCustomerCompany,
            customer_id: selectedCustomer,
            brand_id: selectedBrand,
            customer_cpf: cpf ?? '',
            status_id: selectedStatus,
            admin_id: selectedAdmin,
            associate_seller: associateSeller,
            products: items,
            shipping_fee: convertMoenyToInt(shippingFee),
            shipping_type: selectedShippingType,
            shipping_time: shippingTime,
            shipping_consult: shippingConsult,
            ...paymentPayload(payment),
            shipping_address_id: shippingAddressId,
            comments,
            admin_comments: adminComments
        }).then(res => {
            if(createOrder){
                navigete(`/order/create/${quote?.id}`);
            } else {
                if(!forcedUpdate){
                    getQuote();
                    if(createProposal){
                        setCurrentTab(1);
                        let wrapper = document.querySelector('.wrapper');
                        wrapper.scrollTop = 0;
                    }
                    toast.success('Orçamento atualizado com sucesso');
                }
            }
        }).catch(error => {
            renderError(error);
            setLoading(false);
        });
    }

    const getTotal = () => {
        let toTotal = 0;
        items.map(item => {
            toTotal += item.price * item.quantity;
        });
        
        setSubtotal(`R$ ${convertIntToMoney(toTotal)}`);

        if (selectedShippingType == 'FOB') {
            let feeTax = convertMoenyToInt(shippingFee);
            toTotal += feeTax;
        }
        
        setTotal(`R$ ${convertIntToMoney(toTotal)}`);
    }

    const getItems = () => {
        setItems(quote.items);
    }

    const deleteItem = (id) => {
        setItems(prev => {
            let toItems = [];
            prev.map(item => {
                if(item.id !== id){
                    toItems.push(item);
                }
            });
            return toItems;
        });
        setItemToEdit(null);
    }

    const deleteMultipleItems = () => {
        setLoading(true);

        api.delete(`/budget/item/multiple`, {
            data: {
                ids: selectedIds
            }
        }).then(res => {
            setSelectedIds([]);
            getQuote();
            setShowConfirmMultipleDelete(false);
        }).catch(error => {
            renderError(error);
            setLoading(false);
        });
    }

    const generateItemsData = () => {
        const hasCalculationFeature = hasPlanFeature('calculation');
        const header = ['Imagem', 'SKU', 'Descrição', ...(hasCalculationFeature ? ['Gravações'] : []), 'Quant.', 'Preço unit.', 'Total', ...(hasPermissionToEditBudget ? [''] : [])]; 
        const rows = [];
        
        items.map(item => {
            // const image = <img src={logo.image_url.small} />;
            let image =  null;
            if(item.product_mock_image_url){
                image = <img src={item.product_mock_image_url} />;
            }
            if(item.subproduct.image !== null && image === null){
                image = <img src={item.subproduct.image.image_url.small} />;
            }
            if(item.subproduct.product.images.length > 0 && image === null){
                image = <img src={item.subproduct.product.images[0].image_url.small} />;
            }
            if(image === null){
                image = <img src={ require(`../../assets/images/svgs/default.svg`).default } />;
            }

            let customization = '';

            item.budget_item_customizations.map(itemCustomization => {
                const colors = itemCustomization.quantity_colors === 9999
                    ? '(Full colour)'
                    : `(${itemCustomization.quantity_colors} cor${itemCustomization.quantity_colors !== 1 ? 'es' : ''})`;
                    
                if(itemCustomization?.customization){
                    customization += `${itemCustomization.customization.name} ${colors}<br />`;
                } else if(itemCustomization?.spot_customization) {
                    customization += `${itemCustomization.spot_customization} ${colors}<br />`;
                }
            })

            const rowData = {
                id: item.id,
                data: [
                    image, 
                    item.subproduct.sku,
                    <div dangerouslySetInnerHTML={{__html: item.subproduct.product.name + (item.comments ? `<br><span style="display: inline-block; color: #a6a6a6; padding-top: 6px;">${item.comments ?? ''}</span>` : '')}} />,
                    ...(hasCalculationFeature ? [<div key={item.id} dangerouslySetInnerHTML={{__html: customization}} />] : []),
                    item.quantity, 
                    `R$${convertIntToMoney(item.price)}`, 
                    `R$${convertIntToMoney(item.price * item.quantity)}`
                    // <Button
                    //     type={`transparent`}
                    //     size={`samll`}
                    //     svg={`delete`}
                    //     action={() => deleteItem(item.id)}
                    // />
                ],
                buttons: hasPermissionToEditBudget ? [
                    <Button type={`delete`} svg={`delete`} action={() => setProductToDelete(item.id)} /> 
                ] : [],
                action: () => {
                    if (item.subproduct.product_deleted) {
                        setShowDeletedProductModal(true);
                    } else {
                        setItemToEdit(item);
                    }
                }
            };

            // Adiciona a classe de overlay se o produto estiver deletado
            if (item.subproduct.product_deleted) {
                rowData.className = 'table-row-wrapper';
            }

            rows.push(rowData);
        });

        setItemsData({header, rows});
    }

    // const editItem = item => {
    //     if(!selectedBillingCompany){
    //         toast.error('Escolha a empresa de faturamento');
    //         return;
    //     }

    //     setItemToEdit(item);
    // }

    const generateProposalsData = () => {
        const header = ['Data do envio',  'E-mail enviado', 'Criada por', 'Nome do contato', 'E-mail do contato', 'Total da proposta'];
        const rows = [];
        
        quote.proposals.map(proposal => {
            rows.push({
                data: [
                    moment(proposal.created_at).format('DD/MM/YYYY HH:mm'),
                    proposal.sent ? 'Sim' : 'Não',
                    proposal.admin_name, 
                    proposal.customer_name,
                    proposal.customer_email,
                    `R$${convertIntToMoney(proposal.total)}`,
                ],
                action: () => navigete(`/proposal/${proposal.id}`)
            });
        });

        setProposalsData({header, rows});
    }

    const setCustomerData = customer => {
        setEmail(customer?.email ?? '');
        setPhone(customer?.phone);
        setCpf(customer?.cpf ?? '');
    }

    const ProposalsTab = () => {
        return (
            <Table header={proposalsData.header} rows={proposalsData.rows}/>
        );
    }

    const AttachmentTab = () => {
        return (
            <Table header={attachmentData.header} rows={attachmentData.rows}/>
        );
    }

    const deleteQuote = () => {
        setLoading(true);

        api.delete(`/budget/${id}`).then(res => {
            navigete(getQuoteListReturnUrl());
        }).catch(error => {
            renderError(error);
            setLoading(false);
        });
    }

    const getQuoteListReturnUrl = () => {
        const params = new URLSearchParams(location.search);
        const returnTo = params.get('return_to');

        return returnTo && returnTo.startsWith('/quote/list') ? returnTo : '/quote/list';
    }

    const deleteProduct = () => {
        setLoading(true);

        api.delete(`/budget/item/${productToDelete}`).then(res => {
            setProductToDelete(null);
            getQuote();
        }).catch(error => {
            setLoading(false);
            renderError(error);
        });
    }

    const hasPermissionToEditBudget = hasPermission('edit_budget');

    return (
        <>
            {showAddProduct &&
                <ModalProduct
                    quote={quote}
                    getQuote={getQuote}
                    updateQuote={updateQuote}
                    selectedBillingCompany={selectedBillingCompany}
                    setSelectedBillingCompany={setSelectedBillingCompany}
                    close={() => setShowAddProduct(false)}
                />
            }
            <ModalDelete
                show={showConfirmMultipleDelete}
                text={<p>Tem certeza que deseja apagar <strong>{selectedIds.length} {selectedIds.length > 1 ? 'produtos' : 'produto'}</strong>?</p>}
                action={deleteMultipleItems}
                loading={loading}
                close={() => setShowConfirmMultipleDelete(false)}
            />
            {itemToEdit !== null &&
                <ModalProduct
                    quote={quote}
                    getQuote={getQuote}
                    updateQuote={updateQuote}
                    itemToEdit={itemToEdit}
                    setItemToEdit={setItemToEdit}
                    selectedBillingCompany={selectedBillingCompany}
                    setSelectedBillingCompany={setSelectedBillingCompany}
                    close={() => setItemToEdit(null)}
                />
            }
            <ModalDelete
                show={productToDelete !== null}
                action={deleteProduct}
                loading={loading}
                close={() => setProductToDelete(null)}
            />
            <ModalDelete
                show={confirmDelete}
                action={deleteQuote}
                loading={loading}
                close={() => setConfirmDelete(false)}
            />
            <PanelTemplate id="quote-edit">
                <BoxTabs
                    setTab={setCurrentTab}
                    tab={currentTab}
                    titles={[
                        'Detalhes do orçamento',
                        'Propostas',
                        // 'Anexos',
                    ]}
                    contents={[
                        <QuoteDetailsTab
                            quote={quote}
                            selectedBillingCompany={selectedBillingCompany}
                            setSelectedBillingCompany={setSelectedBillingCompany}
                            selectedStatus={selectedStatus}
                            setSelectedStatus={setSelectedStatus}
                            selectedBudgetType={selectedBudgetType}
                            setSelectedBudgetType={setSelectedBudgetType}
                            selectedCustomerCompany={selectedCustomerCompany}
                            setSelectedCustomerCompany={setSelectedCustomerCompany}
                            selectedCustomer={selectedCustomer}
                            setSelectedCustomer={setSelectedCustomer}
                            selectedBrand={selectedBrand}
                            setSelectedBrand={setSelectedBrand}
                            selectedAdmin={selectedAdmin}
                            setSelectedAdmin={setSelectedAdmin}
                            setAdmins={setAdmins}
                            email={email}
                            phone={phone}
                            cpf={cpf}
                            total={total}
                            subtotal={subtotal}
                            comments={comments}
                            setComments={setComments}
                            adminComments={adminComments}
                            setAdminComments={setAdminComments}
                            selectedShippingType={selectedShippingType}
                            setSelectedShippingType={setSelectedShippingType}
                            shippingFee={shippingFee}
                            setShippingFee={setShippingFee}
                            shippingTime={shippingTime}
                            setShippingTime={setShippingTime}
                            shippingConsult={shippingConsult}
                            setShippingConsult={setShippingConsult}
                            payment={payment}
                            setPayment={setPayment}
                            setCustomerData={setCustomerData}
                            shippingAddressId={shippingAddressId}
                            setShippingAddressId={setShippingAddressId}
                            customerPurchaseOrder={customerPurchaseOrder}
                            setCustomerPurchaseOrder={setCustomerPurchaseOrder}
                            shippingCompany={shippingCompany}
                            setShippingCompany={setShippingCompany}
                        />,
                        <ProposalsTab />,
                        // <AttachmentTab />,
                    ]}
                />
                
                <Box
                    className={`no-padding`}
                    title={`Produtos do orçamento`}
                    tools={hasPermissionToEditBudget &&
                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                            {selectedIds.length > 0 &&
                            <Button 
                            type={`secondary`} 
                            size={`small`} 
                            svg={`delete`}
                            text={`Excluir ${selectedIds.length} selecionados`} 
                            action={() => setShowConfirmMultipleDelete(true)}  
                            />
                        }
                        <Button 
                            type={`secondary`}
                            size={`small`}
                            text={`Adicionar produto`}
                            loading={loading}
                            svg={`plus-blue`}
                            action={() => setShowAddProduct(true)}
                        />
                        </div>
                    }
                >
                    <Table 
                        header={itemsData.header} 
                        rows={itemsData.rows} 
                        checks={hasPermissionToEditBudget} 
                        selectedIds={selectedIds} 
                        setSelectedIds={setSelectedIds}
                    />
                </Box>
                
                <PageFooter spaceBetween={true}>
                    <div>
                        {hasPermissionToEditBudget &&
                            <Button type={`primary`} loading={loading} size={`small`} svg={`save-white`} text={`Salvar alterações`} action={() => saveQuote()} />
                        }
                        {hasPermission('create_proposal') && hasPermissionToEditBudget &&
                            <>
                                <Button type={`secondary`} loading={loading} size={`small`} text={`Atualizar e criar proposta`} action={() => saveQuote(true, false)} />
                                <Button type={`secondary`} loading={loading} size={`small`} svg={`send`} text={`Atualizar e enviar`} action={() => saveQuote(true, true)} />
                            </>
                        }
                    </div>
                    <div>
                        {hasPermission('create_order') && hasPermissionToEditBudget &&
                            <Button type={`secondary`} size={`small`} loading={loading} svg="save" text={`Salvar e emitir pedido`} action={() => saveQuote(false, false, true)} />
                        }
                        {hasQuoteDeletePermission(quote) && hasPermissionToEditBudget &&
                            <Button type={`secondary`} size={`small`} loading={loading} text={`Excluir`} svg={`delete-small`} action={() => setConfirmDelete(true)} />
                        }
                    </div>
                </PageFooter>
            </PanelTemplate>

            <Modal
                className={`modal-associate-seller`}
                title={`Associar responsável`}
                show={sellerConfirm !== null}
                close={() => setSellerConfirm(null)}
                footer={
                    <>
                        <Button type={`primary`} size={`small`} text={`Sim, associar`} action={() => confirmSeller(true)} />
                        <Button type={`secondary`} size={`small`} text={`Não, só neste orçamento`} action={() => confirmSeller(false)} />
                    </>
                }
            >
                <div className="associate-seller-content">
                    <Icon name="user" size={40} />
                    <p>
                        Deseja tornar <strong>{sellerConfirm?.adminName ?? 'este usuário'}</strong> responsável {sellerConfirm?.targets.map((target, index) => (
                            <React.Fragment key={target.label}>
                                {index > 0 && ' e '}
                                {target.label}
                                {target.name && <> <strong>{target.name}</strong></>}
                            </React.Fragment>
                        ))}?
                    </p>
                    <span>Os próximos orçamentos já chegam com ele.</span>
                </div>
            </Modal>

            {showDeletedProductModal && (
                <Modal
                    title="Produto excluído"
                    show={showDeletedProductModal}
                    close={() => setShowDeletedProductModal(false)}
                    footer={ <Button 
                        type={`primary`}
                        size={`small`}
                        text={`Continuar`}
                        loading={loading}
                        action={() => setShowDeletedProductModal(false)}
                    />                    
                }
                >
                    <div  className={`no-padding section`} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <div className="deleted-product-modal">
                            <div className="deleted-product-content">
                                <Icon name="octagon-alert" className="deleted-product-icon" size={48} color="#F59E0B" />

                                <h3 className="deleted-product-title">Produto ou variação excluída</h3>
                                <p className="deleted-product-description">
                                    O produto ou a variação (cor, tamanho, etc) foi excluída e não pode mais ser editada.
                                </p>
                            </div>
                        </div>
                    </div>
                </Modal>
            )}
        </>
    );
}

export default QuoteEdit;
